/**
 * Bouton « S’entraîner » d'un pack sur « Mon année » (migration 0336) : lance /
 * reprend le test si l'élève a débloqué le pack (ou abonnement / pass), sinon
 * cadenas qui mène à la page d'achat du PACK (`/pack/$packId/acheter` : le pack
 * ou son programme ; rien en natif, App Store 3.1.1 — l'écran du test l'explique).
 */

import { Link } from '@tanstack/react-router';
import { ClipboardCheck, Lock } from 'lucide-react';
import { isNativeApp } from '@/lib/platform';
import { packBuyPath } from '@/lib/skillcards/purchase';
import { packTestAction, type PackTestState } from '@/lib/pack-tests';

const BTN =
  'inline-flex min-h-[2.75rem] items-center justify-center gap-1.5 rounded-xl px-4 text-sm font-semibold active:scale-[0.98]';

export function PackTestButton({
  packId,
  state,
}: {
  packId: string;
  state: PackTestState | undefined;
}) {
  const action = packTestAction(state);
  if (action.kind === 'none') return null;

  if (action.kind === 'locked') {
    const label = 'S’entraîner';
    const content = (
      <>
        <Lock className="h-4 w-4" aria-hidden /> {label}
      </>
    );
    const cls = `${BTN} border-ink-200 text-ink-700 shrink-0 border`;
    return (
      <div className="flex items-center justify-between gap-3">
        <span className="text-ink-500 text-xs">Avec le pack débloqué</span>
        {!isNativeApp() ? (
          <a
            href={packBuyPath(packId, '/student/progression')}
            className={cls}
            aria-label="S’entraîner (débloquer le pack)"
          >
            {content}
          </a>
        ) : (
          <Link
            to="/student/progression/test/$packId"
            params={{ packId }}
            className={cls}
            aria-label="S’entraîner (pack à débloquer)"
          >
            {content}
          </Link>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-3">
      <span className="text-ink-500 text-xs">{action.detail ?? ''}</span>
      <Link
        to="/student/progression/test/$packId"
        params={{ packId }}
        className={`${BTN} bg-primary-600 hover:bg-primary-700 shrink-0 text-white`}
      >
        <ClipboardCheck className="h-4 w-4" aria-hidden /> {action.label}
      </Link>
    </div>
  );
}
